import { Moment } from "moment";
import * as moment from "moment";

// models to loading from Server
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { ContentType, ContentTypeGroups } from "../shared/contentTypes";
import { ObjectObserverFactory } from "./objectObserverFactory";
import { appConfig } from "../core-config";
import { MenuSettingsDataModel2, MenuSettingsDMKey } from "../shared/models";
import { ProductObjectObserverData } from "./objectObserver.service";
import { environment } from "../../../environments/environment";

/** ObjectObserver Service for manage the data in storage and over internet */

export class ObjectObserverSyncHelper {
  /** zeitpunkt, wann zuletzt ein serverabgleich aller daten stattgefunden hat */
  private static last_complete_synchronize_with_server: Moment = null;

  /** Synchronisiert die aktuell geladenen Objekte mit dem Server
   * @param helper CircularInjectionHelper
   * @param force ignorierte den last_complete_synchronize_with_server
   * @param setup_sync wird es mit true aufrufen um die initialen assets daten vom server zu laden (siehe get_server_data.ts)
  */
  public static CompleteSynchronizeWithServer(helper: CircularInjectionHelper, force: boolean, setup_sync: boolean = false): Promise<void> {
    // if not force, then it must have a difference of X minutes befor download again
    if (!force && ObjectObserverSyncHelper.last_complete_synchronize_with_server && moment().diff(ObjectObserverSyncHelper.last_complete_synchronize_with_server, "minutes", false) < appConfig.sync_interval) {
      return Promise.resolve();
    }

    // check has Internet, without server skip this sync job (by force call reject)
    if (!helper.coreCOMService.environment.networkInformation.isOnline) {
      if (force) {
        return Promise.reject("no internet");
      } else {
        helper.coreLogService.error("ObjectObserverSyncHelper.CompleteSynchronizeWithServer", "no internet, skip sync with server");
        return Promise.resolve();
      }
    }

    return new Promise<void>(async (resolve) => {
      // die gewünschten Observer durchlaufen (synchrone um den server zu entlasten und das ende zu dokumentieren)
      for (const contentType of ContentTypeGroups.autoSyncAllowedContentTypes(environment.producttype, setup_sync)) {
        const RealeasAfterSync = !ObjectObserverFactory.ContainsObjectObserver(contentType);
        const objObserver = ObjectObserverFactory.GetObjectObserverByInjectionHelper(contentType, helper);
        if (objObserver.SynchronizingWithServer) {
          try { // erstens die Serverdaten abholen
            await objObserver.RefreshObjectsFromServer();
          } catch (error) {
            helper.coreLogService.error("ObjectObserverSyncHelper.CompleteSynchronizeWithServer", "objObserver.RefreshObjectsFromServer", error);
          }
          try { // zweitens die nicht übertragenen Daten an den Server senden
            await objObserver.SynchronizeObjectsWithServer();
          } catch (error) {
            helper.coreLogService.error("ObjectObserverSyncHelper.CompleteSynchronizeWithServer", "objObserver.SynchronizeObjectsWithServer", error);
          }
        }

        // MenuSettings syncs the Products by the settings, because it says with loacatoins and sortiment
        if (contentType == ContentType.MenuSettings) {
          // Attention modelMenuSettings is only DataModel not MenuSettingsDataModel (only simple type calls working, no functions)
          const modelMenuSettings = <MenuSettingsDataModel2>(await objObserver.GetObject(MenuSettingsDMKey));
          for (let index = 0; index < modelMenuSettings.locations.length; ++index) {
            const data = new ProductObjectObserverData(modelMenuSettings.locations[index], modelMenuSettings.sortiment);
            const RealeasProductAfterSync = !ObjectObserverFactory.ContainsObjectObserver(ContentType.sub_Product, data);
            const productObjObserver = await ObjectObserverFactory.GetObjectObserverByInjectionHelper(ContentType.sub_Product, helper, data);
            if (productObjObserver.SynchronizingWithServer) {
              try { // erstens die Serverdaten abholen
                await productObjObserver.RefreshObjectsFromServer();
              } catch (error) {
                helper.coreLogService.error("ObjectObserverSyncHelper.CompleteSynchronizeWithServer", "productObjObserver.RefreshObjectsFromServer", error);
              }
              try { // zweitens die nicht übertragenen Daten an den Server senden
                await productObjObserver.SynchronizeObjectsWithServer();
              } catch (error) {
                helper.coreLogService.error("ObjectObserverSyncHelper.CompleteSynchronizeWithServer", "productObjObserver.SynchronizeObjectsWithServer", error);
              }
            }
            if (RealeasProductAfterSync) {
              ObjectObserverFactory.ReleaseObjectObserver(ContentType.sub_Product, data);
            }
          }
        }

        if (RealeasAfterSync) {
          ObjectObserverFactory.ReleaseObjectObserver(contentType);
        }
      }

      // ATTENTION: Look to the get_server_data.ts, if change something
      ObjectObserverSyncHelper.last_complete_synchronize_with_server = moment();
      resolve();
    });
  }

  /** Privat darf nicht genutzt werden, dafür ist die Statische Function GetObjectObserver */
  private constructor() {
  }

}
